export class FilterEventManager {
  constructor(container, options = {}) {
    this.container = container;
    this.onMultiSelectToggle = options.onMultiSelectToggle || (() => {});
    this.onFilterChange = options.onFilterChange || (() => {});
    this.onMineralCategoryChange = options.onMineralCategoryChange || (() => {});
    this.onReset = options.onReset || (() => {});
    this.onDocumentClick = options.onDocumentClick || (() => {});
  }

  attachEventListeners() {
    // Multi-select toggle handlers
    this.container.addEventListener('click', (e) => {
      if (e.target.classList.contains('multi-select-toggle')) {
        this.onMultiSelectToggle(e.target);
      }

      // Handle clicks on checkmark spans to trigger checkbox
      if (e.target.classList.contains('checkmark')) {
        const checkbox = e.target.parentElement.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          // Trigger change event to fire our existing handlers
          const changeEvent = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(changeEvent);
        }
      }
    });

    // Checkbox change handlers - use event delegation for dynamically added checkboxes
    this.container.addEventListener('change', (e) => {
      if (e.target.type === 'checkbox' && e.target.dataset.filter) {
        console.log('📝 Checkbox changed:', e.target.dataset.filter, e.target.value, e.target.checked);

        // Handle special mineral category changes
        if (e.target.dataset.filter === 'minerals' &&
            (e.target.value === 'critical-minerals-only' || e.target.value === 'non-critical-minerals-only')) {
          this.onMineralCategoryChange(e.target);
        } else {
          this.onFilterChange(e.target);
        }
      }
    });

    // Reset filters
    const resetBtn = this.container.querySelector('#resetFilters');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        this.onReset();
      });
    }

    // Close multi-selects when clicking outside
    this.documentClickHandler = (e) => {
      if (!e.target.closest('.custom-multi-select')) {
        this.onDocumentClick();
      }
    };
    document.addEventListener('click', this.documentClickHandler);
  }

  destroy() {
    if (this.documentClickHandler) {
      document.removeEventListener('click', this.documentClickHandler);
    }
  }
}